import { render, staticRenderFns } from "./ModalDeleteMassiveCustomers.vue?vue&type=template&id=0444dc05&scoped=true&"
import script from "./ModalDeleteMassiveCustomers.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteMassiveCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444dc05",
  null
  
)

export default component.exports